import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { websiteUrl } from "../../const/constants";
import axios from "axios";

// import AMN from "../../Assets/images/AMN.png";

const API_URL = `${websiteUrl}/api/about`;

const AMNTaaruf = () => {
  const navigate = useNavigate();
  const [about, setAbout] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    setLoading(true);
    axios
      .get(`${API_URL}?section_key=amntaaruf&active=1`)
      .then((res) => {
        if (res.data.success && res.data.data && res.data.data.length > 0) {
          setAbout(res.data.data[0]);
        } else {
          setAbout(null);
        }
        setLoading(false);
      })
      .catch(() => {
        setAbout(null);
        setLoading(false);
      });
  }, []);

  const handleSeeMore = () => {
    navigate("/taaruf");
  };

  if (loading) {
    return (
      <div className="flex justify-center items-center h-40">
        <div className="animate-spin rounded-full h-10 w-10 border-t-4 border-primary border-solid"></div>
      </div>
    );
  }
  if (!about) {
    return (
      <div className="text-center text-gray-500 py-8">
        کوئی تعارف دستیاب نہیں
      </div>
    );
  }

  return (
    <div className="flex flex-col lg:flex-row gap-4 md:gap-8 lg:gap-14 lg:mt-20 md:mt-18 mt-10 px-8 md:px-16  mb-10">
      <div className="text-start">
        <h2 className="font-nastaleeqKasheeda text-2xl md:text-3xl lg:text-4xl">
          {about.section_title}
        </h2>
        <p className="mt-5 lg:mt-5 md:mt-8 tracking-[0.1rem] text-lg sm:text-xl md:text-xl lg:text-2xl">
          {about.section_content}
        </p>
        <button
          onClick={handleSeeMore}
          className="mt-5 lg:mt-5 md:mt-8 text-xl md:text-xl lg:text-2xl text-primary underline"
        >
          تفصیل دیکھیں
        </button>
      </div>
      {about.image && (
        <img
          src={`${websiteUrl}/api/about/aboutImage/${about.image}`}
          alt="AMN"
          className="mx-auto max-w-xs md:max-w-sm lg:max-w-md w-full h-auto"
        />
      )}
    </div>
  );

  /*
    return (
        <div className="flex flex-col lg:flex-row gap-4 md:gap-8 lg:gap-14 lg:mt-20 md:mt-18 mt-10 px-8 md:px-16 lg:px-52 mb-10">
            <div className="text-start">
                <h2 className="font-nastaleeqKasheeda text-2xl md:text-3xl lg:text-4xl">ایسوسی ایشن آف مشتاقان نور</h2>
                <p className="mt-5 lg:mt-5 md:mt-8 text-lg md:text-xl lg:text-xl">
                    امن نے تعلیمات محمد و آل محمد علیہم السلام کی روشنی میں بچوں کی تربیت کے لئے کلاسز کا ایسا نظام روشناس کروایا ہے جو امام محمد باقر (ع) کی سیرت سے متاثر ہو کر قائم کی گئی ہیں۔ امام محمد باقر (ع) نے اسی طرح کی کلاسز کے ذریعے لوگوں میں اسلامی معارف عام کئے اور شاگردوں کی تربیت کے بعد انہیں دور دراز علاقوں میں بھیجاتاکہ وہ بھی درست عقائد لوگوں تک پہنچائیں ۔
                </p>
                <button onClick={handleSeeMore} className="mt-5 lg:mt-5 md:mt-8 text-xl md:text-xl lg:text-2xl text-primary underline">تفصیل دیکھیں</button>
            </div>
            <img src={AMN} alt="AMN" className="mx-auto max-w-xs md:max-w-sm lg:max-w-md w-full h-auto" />
        </div>
    )
    */
};

export default AMNTaaruf;
